import * as Yup from "yup";
import { WhiteLabelConfig } from "../../api/types/WhiteLabelConfig";

export const whiteLabelIntialValues: WhiteLabelConfig = {
  domain: "",
  brand_name: "",
  color_dark: "",
  color_bright: "",
  color_pale: "",
  color_faded: "",
  login_screen_logo: null,
  landing_page_heading: "",
  landing_page_content: "",
  landing_page_image: null,
  logo_image: null,
  favicon: null,
  meta_title: "",
  meta_description: "",
};

export const whiteLabelValidationSchema = Yup.object().shape({
  // domain: Yup.string().url("Enter a valid URL").required("Domain is required"),
  domain: Yup.string().required("Domain is required"),
  brand_name: Yup.string().required("Brand name is required"),
  color_dark: Yup.string()
    .matches(/^#([0-9A-F]{3,4}){1,2}$/i, "Enter a valid hex color")
    .required("Dark color is required"),
  color_bright: Yup.string()
    .matches(/^#([0-9A-F]{3,4}){1,2}$/i, "Enter a valid hex color")
    .required("Bright color is required"),
  color_pale: Yup.string()
    .matches(/^#([0-9A-F]{3,4}){1,2}$/i, "Enter a valid hex color")
    .required("Pale color is required"),
  color_faded: Yup.string()
    .matches(/^#([0-9A-F]{3,4}){1,2}$/i, "Enter a valid hex color")
    .required("Faded color is required"),
  // login_screen_logo: Yup.mixed().required("Login screen logo is required"),
  landing_page_heading: Yup.string()
    .max(60, "Max 60 characters")
    .required("Landing page heading is required"),
  landing_page_content: Yup.string()
    .max(160, "Max 160 characters")
    .required("Landing page content is required"),
  // landing_page_image: Yup.mixed().required("Landing page image is required"),
  // logo_image: Yup.mixed().required("Logo image is required"),
  // favicon: Yup.mixed().required("Favicon is required"),
  meta_title: Yup.string()
    .max(60, "Max 60 characters")
    .required("Meta title is required"),
  meta_description: Yup.string()
    .max(160, "Max 160 characters")
    .required("Meta description is required"),
});
